import { render, staticRenderFns } from "./see.vue?vue&type=template&id=2c4f5fea"
import script from "./see.vue?vue&type=script&lang=js"
export * from "./see.vue?vue&type=script&lang=js"
import style0 from "./see.vue?vue&type=style&index=0&id=2c4f5fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports